module.exports = __webpack_public_path__ + "edf9f4066c3d376d940dde889177b2e8.pdf";